import { useEffect, useState } from 'react';
import { VoiceCallService } from '../../services/voice-call.service';

const useCallUsageBannerHook = (learnerId) => {
  const [maxCallDurationPerCall, setMaxCallDurationPerCall] = useState(null);
  const [maxCallDurationPerDay, setMaxCallDurationPerDay] = useState(null);
  const [consumedCallDurationPerDay, setConsumedCallDurationPerDay] = useState(null);
  const [remainingCallDurationPerDay, setRemainingCallDurationPerDay] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [hasValidData, setHasValidData] = useState(false);
  const voiceCallService = new VoiceCallService();
 
  useEffect(() => {
    if (learnerId) {
      fetchCallUsage();
    }
  }, [learnerId]);

  const fetchCallUsage = async () => {
    try {
      setIsLoading(true);
      setHasValidData(false);
      const response = await voiceCallService.getCallHistoryUsageForLearner(learnerId);
      if (response) {
        const { maxCallDurationPerCall, maxCallDurationPerDay, consumedCallDurationPerDay, remainingCallDurationPerDay } =
          response;
        
        // Check if all required values are present and valid
        const isValidData = 
          maxCallDurationPerCall !== null && 
          maxCallDurationPerCall !== undefined && 
          maxCallDurationPerDay !== null && 
          maxCallDurationPerDay !== undefined && 
          consumedCallDurationPerDay !== null && 
          consumedCallDurationPerDay !== undefined && 
          remainingCallDurationPerDay !== null && 
          remainingCallDurationPerDay !== undefined;
        
        if (isValidData) {
          setMaxCallDurationPerCall(maxCallDurationPerCall);
          setMaxCallDurationPerDay(maxCallDurationPerDay);
          determineCallTimeLimitAvailibilty(
            consumedCallDurationPerDay,
            remainingCallDurationPerDay,
            maxCallDurationPerDay,
            maxCallDurationPerCall
          );
          setHasValidData(true);
        } else {
          console.error('Invalid or missing data in call usage response', response);
          setHasValidData(false);
        }
      } else {
        console.error('Error fetching call usage', response);
        setHasValidData(false);
      }
    } catch (error) {
      console.error('Error fetching call usage', error);
      setHasValidData(false);
    } finally {
      setIsLoading(false);
    }
  };


  const determineCallTimeLimitAvailibilty = (consumed, remaining) => {
    const formattedConsumed = converTimeIntoMintuesAndSeconds(consumed);
    const formattedRemaining = converTimeIntoMintuesAndSeconds(remaining);

    setConsumedCallDurationPerDay(formattedConsumed);
    setRemainingCallDurationPerDay(formattedRemaining);
  };

  const converTimeIntoMintuesAndSeconds = (duration) => {
    const minutes = Math.floor(duration);
    const seconds = Math.round((duration - minutes) * 60);
    let totalMinutes = 0;
    if (seconds >= 1 && seconds <= 59) totalMinutes = minutes + 1;
    else totalMinutes = minutes;

    return totalMinutes === 1
      ? `${totalMinutes} minute`
      : `${totalMinutes} minutes`;
  };


  const updateCallUsages = () => {
    fetchCallUsage();
  };

  return {
    maxCallDurationPerCall,
    maxCallDurationPerDay,
    consumedCallDurationPerDay,
    remainingCallDurationPerDay,
    isLoading,
    hasValidData,
    updateCallUsages,
  };
};

export default useCallUsageBannerHook;
